import PromoCode from './promo_code';

export default PromoCode;
